export default "__VITE_ASSET__CFFd9ltv__"